import { Button } from "flowbite-react";
import React, { useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useLocation } from "react-router-dom";
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const PostDescription = () => {
  const location = useLocation();
  const { fileOption } = location.state || {};
 
  const [editorContent, setEditorContent] = useState("");
  
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };
  
  const handleSave = () => {
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <SEO
        title="Post Description"
        description="Create and manage post descriptions for your film project updates on ProducerBuddy."
        url="https://producerbuddy.pilomation.com/post-description"
        robots="noindex, nofollow"
      />
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold mb-4 text-gray-700 text-center">
            Post 
        </h2>
        <div className="text-center text-gray-700 mb-4">
          <p>{fileOption ? `Selected Post: ${fileOption}` : "No post selected"}</p>
        </div>
        <ReactQuill theme='snow' value={editorContent} className="h-75" onChange={handleEditorChange} placeholder='Write something...'/>
        <div className="mt-4 text-center">
          <Button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-600 transition duration-300" onClick={handleSave}>
            Save Post
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PostDescription;

